export default __webpack_public_path__ + "8dda492e4e0967498327181c1d62f56a.js";